import * as React from 'react';
import { FormNumberInput } from '../form-number-input/FormNumberInput';

export type FormInputProps = React.DetailedHTMLProps<React.InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> & {
	increment?: number;
};

interface ICurrencyProps extends FormInputProps {
	widthtype?: 'narrow' | 'half' | 'normal' | 'wide' | 'full';
	showValidationError?: 'true' | 'false';
	currency?: string;
}

export const FormInputCurrency = (props: ICurrencyProps) => {
	const { type, widthtype, readOnly, showValidationError, currency } = props;

	if (type === 'number') {
		return <FormNumberInput {...props} />;
	}

	const convertCurrency = (c: string | undefined): string => {
		const upperCaseCurrency = c?.toUpperCase();
		switch (upperCaseCurrency) {
			case 'USD':
				return '$';
			case 'EUR':
				return '€';
			case 'GBP':
			default:
				return '£';
		}
	};

	const containerClassList = ['form__input--container', `form__input--container--${type}`, 'form__input--input-currency-icon'];

	if (widthtype) {
		containerClassList.push(`form__input--container--${widthtype}`);
	} else {
		containerClassList.push('container');
	}

	const classList = ['form__input'];

	if (type) {
		classList.push(`form__input--${type}`);
	}

	if (showValidationError === 'true') {
		classList.push('form__input--currency-error');
	}

	if (readOnly) {
		classList.push('form__input--readonly');
	}

	return <>
		<div className={containerClassList.join(' ')}>
			<input className={classList.join(' ')} {...props} />
			<i style={{fontSize:'var(--font-size-c1)'}}>{convertCurrency(currency)}</i>
		</div >
	</>;
};
